import { render, staticRenderFns } from "./RejeicaoDocumentoNovo.vue?vue&type=template&id=7360304c"
import script from "./RejeicaoDocumentoNovo.vue?vue&type=script&lang=js"
export * from "./RejeicaoDocumentoNovo.vue?vue&type=script&lang=js"
import style0 from "./RejeicaoDocumentoNovo.vue?vue&type=style&index=0&id=7360304c&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports